import {
    createVNode as _$cv,
    noop as _$no,
    createUnknownComponentVNode as _$cc,
    createElementVNode as _$ce,
    className as _$cn,
    map as _$ma,
} from 'intact';
import {Button} from '../button';
import {Progress} from '../progress';
import {Dialog} from '../dialog';
import {expandAnimationCallbacks, getRestProps} from '../utils';
import {makeStyles, makeUploadDialogStyles} from './styles';
import {TransitionGroup, Transition, linkEvent} from 'intact';
import {_$} from '../../i18n';
import {Icon} from '../icon';
import {UploadFileStatus} from './useUpload';

var _$tmp0 = {
    'className': 'ion-upload'
};
var _$tmp1 = {
    'className': 'k-upload-picture-card k-upload-add ion-ios-plus-empty'
};
var _$tmp2 = {
    'className': 'k-upload-zoom ion-ios-eye-outline'
};
var _$tmp3 = {
    'className': 'k-upload-file-icon ion-document'
};
var _$tmp4 = {
    'className': 'k-upload-status-icon ion-ios-checkmark-outline'
};
var _$tmp5 = {
    'className': 'k-upload-status-icon ion-ios-close-outline'
};

export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    var _$blocks = {};
    var __$blocks = {};
    
    const {
        className, accept, multiple, limit,
        files, children, type, directory
    } = this.get();
    
    const drag = this.drag;
    const classNameObj = {
        'k-upload': true,
        [className]: className,
        'k-drag': type === 'drag', 
        'k-dragover': drag.dragOver.value, 
        'k-gallery': type === 'gallery',
        [makeStyles()]: true,
    };
    
    const events = {
        'ev-click': this.selectFile,
    };
    if (type === 'drag') {
        events['ev-dragover'] = drag.stopEvent;
        events['ev-dragenter'] = drag.onDragEnter;
        events['ev-dragleave'] = drag.onDragLeave;
        events['ev-drop'] = drag.onDrop;
    }
    
    const handle = (
        _$cv('div', {
            'className': 'k-upload-handle',
            ...events
        }, (
            (
                (_$blocks['content'] = function($super) {
                    return (
                        (children) ?
                            (
                                (_$blocks['children'] = function($super) {
                                    return children;
                                }),
                                (__$blocks['children'] = function($super, data) {
                                    var block = $blocks['children'];
                                    var callBlock = function() {
                                        return _$blocks['children'].call($this, $super, data);
                                    };
                                    return block ?
                                        block.call($this, callBlock, data) :
                                        callBlock();
                                }),
                                __$blocks['children'](_$no)
                            ) :
                            type !== 'gallery' ?
                                (
                                    (type === 'select') ?
                                        _$cc(Button, {
                                            'type': 'primary',
                                            'children': _$('点击上传')
                                        }) :
                                        _$ce(2, 'div', [
                                            _$cc(Icon, _$tmp0),
                                            _$ce(2, 'div', _$('将文件拖到此处，或点击上传'), 0)
                                        ], 4, 'k-upload-area')
                                ) :
                                (
                                    _$cc(Icon, _$tmp1)
                                )
                    );
                }),
                (__$blocks['content'] = function($super, data) {
                    var block = $blocks['content'];
                    var callBlock = function() {
                        return _$blocks['content'].call($this, $super, data);
                    };
                    return block ?
                        block.call($this, callBlock, data) :
                        callBlock();
                }),
                __$blocks['content'](_$no)
            )
        ))
    );
    
    const {removeFile} = this.files;
    const closeBtn = (value, index, icon) => (
        _$cc(Icon, {
            'className': _$cn({"k-upload-close": true, [icon]: true}),
            'ev-click': () => removeFile(value, index),
            'hoverable': true
        })
    );
    
    const {show, close, image, isShow} = this.showImage;
    
    return _$cv('div', {
        'className': _$cn(classNameObj),
        ...getRestProps(this)
    }, [
        _$ce(64, 'input', null, 1, 'c-hidden', {
            'type': 'file',
            'accept': accept,
            'ev-change': this.onInputChange,
            'multiple': multiple,
            'directory': directory ? '' : undefined,
            'webkitdirectory': directory ? '' : undefined
        }, null, this.inputRef),
        (type === 'gallery') ?
            _$ce(2, 'div', (
                _$cc(TransitionGroup, {
                    'name': 'k-dropdown',
                    'children': [
                        _$ma(files, function($value, $key) {
                            return _$ce(2, 'div', [
                                _$ce(2, 'img', null, 1, 'k-upload-img', {
                                    'src': $value.url
                                }),
                                _$cc(Transition, {
                                    'name': 'k-fade',
                                    'children': (
                                        ($value.status === UploadFileStatus.Ready || 
                                        $value.status === UploadFileStatus.Uploading) ?
                                            _$ce(2, 'div', (
                                                _$cc(Progress, {
                                                    'percent': $value.percent,
                                                    'size': 'mini',
                                                    'className': 'k-upload-progress'
                                                })
                                            ), 2, 'k-upload-overlap', null, 'overlap') :
                                            _$ce(2, 'div', (
                                                _$cc(Icon, _$tmp2)
                                            ), 2, 'k-upload-overlap k-upload-icons', {
                                                'ev-click': linkEvent($value, show)
                                            })
                                    )
                                }),
                                closeBtn($value, $key, 'ion-ios-close')
                            ], 0, _$cn({
                                "k-upload-picture k-upload-picture-card": true, 
                                'k-error': $value.status === UploadFileStatus.Error,
                            }), null, $value.uid);
                        }, $this),
                        (!limit || files.length < limit) ?
                            _$ce(2, 'div', handle, 0, 'c-middle', null, 'handle') :
                            undefined
                    ]
                })
            ), 2, 'k-upload-pictures') :
            handle,
        ($blocks.tip) ?
            _$ce(2, 'div', (
                (
                    (_$blocks['tip'] = function($super) {
                        return null;
                    }),
                    (__$blocks['tip'] = function($super, data) {
                        var block = $blocks['tip'];
                        var callBlock = function() {
                            return _$blocks['tip'].call($this, $super, data);
                        };
                        return block ?
                            block.call($this, callBlock, data) :
                            callBlock();
                    }),
                    __$blocks['tip'](_$no)
                )
            ), 0, 'k-upload-tip') :
            undefined,
        (type !== 'gallery') ?
            _$ce(2, 'div', (
                _$cc(TransitionGroup, {
                    ...expandAnimationCallbacks,
                    'children': (
                        _$ma(files, function($value, $key) {
                            return _$ce(2, 'div', [
                                _$ce(2, 'div', [
                                    _$cc(Icon, _$tmp3),
                                    _$ce(2, 'span', $value.name, 0, 'k-upload-file-name'),
                                    closeBtn($value, $key, 'ion-ios-close-empty'),
                                    ($value.status === UploadFileStatus.Done) ?
                                        _$cc(Icon, _$tmp4) :
                                        $value.status === UploadFileStatus.Error ?
                                            _$cc(Icon, _$tmp5) :
                                            undefined
                                ], 0, 'k-upload-name c-ellipsis'),
                                _$cc(Transition, {
                                    ...expandAnimationCallbacks,
                                    'children': (
                                        ($value.status === UploadFileStatus.Ready || 
                                        $value.status === UploadFileStatus.Uploading) ?
                                            _$cc(Progress, {
                                                'percent': $value.percent,
                                                'size': 'mini',
                                                'className': 'k-upload-progress'
                                            }) :
                                            undefined
                                    )
                                })
                            ], 4, _$cn({
                                "k-upload-file": true,
                                'k-error': $value.status === UploadFileStatus.Error
                            }), null, $value.uid);
                        }, $this)
                    )
                })
            ), 2, 'k-upload-files') :
            undefined,
        _$cc(Dialog, {
            'title': _$("查看图片"),
            'key': 'dialog',
            'value': isShow.value,
            'ev-close': close,
            'className': _$cn({"k-upload-dialog": true, [makeUploadDialogStyles()]: true}),
            'children': (
                (image.value) ?
                    _$ce(2, 'a', (
                        _$ce(2, 'img', null, 1, null, {
                            'src': image.value.url
                        })
                    ), 2, null, {
                        'href': image.value.url,
                        'target': '_blank'
                    }) :
                    undefined
            )
        }, 'dialog')
    ]);
};